export default __webpack_public_path__ + "static/media/payment-mastercard.6b0bf6dc.svg";